/**
 * Name of plugins to be ignored.
 * Plugins with these names will not be added into editor
 */
export const IgnoredPluginNames = [
    'TableCellSelection', // Ignore TableCellSelection plugin since its functionality is already integrated into SelectionPlugin
];
